import classNames from "classnames";
import React from "react";
import {CloseGray} from "@komponentkassen/svv-icons";
import {SVVConditionalWrapper} from "@komponentkassen/svv-layout";

type InformationMessageProps = React.PropsWithChildren<{
  type: "error" | "warning" | "info" | "success" | "standard";
  isCenter?: boolean;
  isFullWidth?: boolean;
  className?: string;
  closeText?: string;
  heading?: string;
  headingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  onDismiss?: () => void;
}>

function messageModifierClass(type: string) {
  switch (type) {
    case "error":
      return "svv-info-message--error";
    case "warning":
      return "svv-info-message--warning";
    case "info":
      return "svv-info-message--info";
    case "success":
      return "svv-info-message--success";
    default:
      return "svv-info-message--standard";
  }
}

const CloseButton = ({onDismiss, closeText}: {onDismiss: () => void, closeText: string}) => (
  <button
    className="svv-info-message__close-button"
    type="button"
    onClick={onDismiss}
  >
    <CloseGray
      aria-hidden
      className="svv-info-message__close_icon"
    />
    <span>{closeText}</span>
  </button>
)

export function SVVInformationMessage({
                                        type,
                                        isCenter,
                                        isFullWidth,
                                        className,
                                        children,
                                        heading,
                                        closeText = "Lukk",
                                        onDismiss,
                                        headingLevel = "h2"
                                      }: InformationMessageProps) {
  const modifierClass = messageModifierClass(type);
  const Heading = headingLevel;

  return (
    <div
      className={classNames(
        "svv-info-message",
        modifierClass,
        {
          "svv-info-message--center": isCenter,
          "svv-info-message--fullWidth": isFullWidth,
          "svv-info-message--padded": onDismiss
        },
        className,
      )}
    >
      <div className="svv-info-message__content">
        <SVVConditionalWrapper
          condition={!!heading}
          renderWrapper={() => (
            <div className="svv-info-message__header">
              <Heading className="svv-info-message__heading">
                {heading}
              </Heading>
              {onDismiss &&
                <CloseButton onDismiss={onDismiss} closeText={closeText!}/>
              }
            </div>
          )}
        >
          {onDismiss &&
            <CloseButton onDismiss={onDismiss} closeText={closeText!}/>
          }
        </SVVConditionalWrapper>
        {children}
      </div>
    </div>
  );
}
